import React, { Component } from 'react'
import { withStyles } 		from 'material-ui/styles'
import { connect } 			from 'react-redux'

const styles = {}

class Countries extends Component {
	constructor(props) {
		super(props)

		this.state = {}
	}

	render() {
		return(
			<div>
				Countries
			</div>
		)
	}
}

export default withStyles(styles)(Countries);



// WEBPACK FOOTER //
// ./src/components/content/Countries.js